/**
 * API Service
 *
 * Centralized API interface for the application.
 * Uses direct Firestore access with security rules for data operations.
 * This is a production-ready pattern that avoids Cloud Functions Gen 2 CORS issues.
 * Supports demo mode with mock data.
 */

import { isDemoMode } from './firebase';
import { mockApi } from './mockData';
import firestoreApi from './firestoreApi';

// Use mock API in demo mode, direct Firestore API otherwise
const api = isDemoMode ? mockApi : firestoreApi;

export default api;

// Re-export individual APIs for direct access if needed
export {
  employeeApi,
  leaveApi,
  payrollApi,
  reportApi,
  policyApi,
  forecastApi,
  chatApi,
  dashboardApi,
  configApi,
} from './firestoreApi';
